import { SegmentsMonthlyVisitsGraphWidget } from "./SegmentsMonthlyVisitsGraphWidget";
import type { DashboardMetric } from "./type";

export class SegmentsPageViewsGraphWidget extends SegmentsMonthlyVisitsGraphWidget {
    metric: DashboardMetric;

    constructor() {
        super();
        this.metric = "PagesViews";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return "SegmentsPageViewsGraph";
    }
}

SegmentsPageViewsGraphWidget.register();
